const getUrlVars = () => {
    var variables = [],
        vars,
        parameters = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

    for (var i = 0; i < parameters.length; i++) {
        vars = parameters[i].split('=');
        variables.push(vars[0]);
        variables[vars[0]] = vars[1];
    }

    return variables;
};

const getUrlVar = (name) => {
    return getUrlVars()[name];
};

window.getUrlVar = getUrlVar
window.getUrlVars = getUrlVars

export {
    getUrlVars,
    getUrlVar
}
